import axios from "axios";
import { QueryClient, useQuery } from "react-query";
import { Base_Api_Url } from "../config/config";

async function fetcher<T>(url: string): Promise<T> {
  try {
    const response = await axios.get(`${Base_Api_Url}/` + url);
    return response.data;
    //throw new Error("Error while fetching data");
  } catch (error) {
    throw new Error("Error while fetching data. Error:- " + error);
  }
}

export function useCacheData<T>(
  key: string,
  url: string,
  staletime: number | undefined = Infinity,
  cachesTime: number | undefined = Infinity
): any {
  const { data, error, isLoading } = useQuery<T, Error>(
    key,
    () => fetcher<T>(url),
    {
      cacheTime: cachesTime,
      staleTime: staletime, // 7 days
    }
  );

  return { data, error, isLoading };
}

export function RefetchCache(key: string, client: QueryClient): Promise<void> {  
  return client.refetchQueries(key);
}
